const raqeebMenu = [
  {
    System: 'RAQ',
    isActive: false,
    menu: [
      { is_header: true, title: 'attendanceManagement', isActive: true }, // عنوان القائمة الرئيسي

 
      {
        path: '/RAQ/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      {
        path: '/RAQ/RotationPlan',
        icon: 'fas fa-calendar-alt',
        title: 'RotationPlan',
        permission: 'ViewListRaqRotationPlans',
        isActive: true
      },
      {
        path: '/RAQ/UpdateRaqeebData',
        icon: 'fas fa-database',
        title: 'UpdateAttendanceData',
        permission: 'RAQAddUpdateAnalysisResults',
        isActive: true
      },
      {
        path: '/RAQ/AttendancAnalysis',
        icon: 'fas fa-user-clock',
        title: 'AttendanceAnalysis',
        permission: 'AttendanceDataAnalysisReport',
        isActive: true
      },
      {
        path: '/RAQ/AllFingerPrint',
        icon: 'fas fa-user-clock',
        title: 'FingerprintData',
        permission: 'RAQFingerprintDataDetails',
        isActive: true
      },
      {
        path: '/RAQ/AttendanceAdjustment',
        icon: 'fas fa-user-clock',
        title: 'AttendanceRequests',
        permission: 'listRaqPermissions',
        isActive: true
      },
      {
        path: '/RAQ/Holidays',
        icon: 'fas fa-umbrella-beach',
        title: 'Holidays',
        permission: 'listRaqHoliday',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/RAQ/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/RAQ/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
        // highlight: true,
      }

      // { is_header: true, title: 'RAQEEB', isActive: true },
      // {
      //   path: 'dashboard',
      //   icon: 'fas fa-home',
      //   title: 'HomePage',
      // },

      // {
      //   path: '/RAQ',
      //   icon: 'far fa-clock',
      //   title: 'attendancePlan',
      //   children: [
      //     {
      //       path: 'RAQ/RotationPlan',
      //       title: 'RotationPlan',
      //       isActive: HasPermission('ViewListRaqRotationPlans'),
      //     },
      //     {
      //       path: 'RAQ/AttendancAnalysis',
      //       title: 'AttendanceAnalysis',
      //       isActive: HasPermission('AttendanceDataAnalysisReport'),
      //     },
      //     {
      //       path: 'RAQ/UpdateRaqeebData',
      //       title: 'UpdateAttendanceData',
      //       isActive: HasPermission('RAQAddUpdateAnalysisResults'),
      //     },
      //   ],
      // },
    ]
  }
];

export default raqeebMenu;
